import Box from "@mui/material/Box/Box";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import { InputSearchIconUI } from "../styles/styles";

interface InputFieldIcons {
  iconStart: any;
  InputProps: any;
  secondIcon?: any;
  value?: any;
  placeholder?: string;
  elementRef?: any;
}

type AllProps = InputFieldIcons;

const FormInputFieldIcon: React.FC<AllProps> = ({
  iconStart,
  InputProps,
  secondIcon,
  placeholder,
  elementRef,
  ...props
}: AllProps) => {
  const handleKeyDown = (event: any) => {
    const value = event.target.value.trim();
    if (event.key === " " && !value.trim()) {
      event.preventDefault();
    }
  };

  return (
    <Box>
      <TextField
        {...props}
        variant="standard"
        placeholder={placeholder}
        onKeyDown={handleKeyDown}
        inputRef={elementRef}
        slotProps={{
          input: {
            onKeyDown: (e: React.KeyboardEvent) => {
              if (e.key === "Enter") {
                e.stopPropagation();
              }
            },
            ...InputProps,
            startAdornment: iconStart ? (
              <>
                <InputAdornment position="start" sx={InputSearchIconUI}>
                  {iconStart}
                </InputAdornment>
                {secondIcon && (
                  <InputAdornment position="start" sx={InputSearchIconUI}>
                    {secondIcon}
                  </InputAdornment>
                )}
              </>
            ) : (
              secondIcon && (
                <InputAdornment position="start" sx={InputSearchIconUI}>
                  {secondIcon}
                </InputAdornment>
              )
            ),
          },
        }}
      />
    </Box>
  );
};

export default FormInputFieldIcon;
